<template>
    <div class="viewContainer">
        <v-container>
            <v-row class="mb-5 mt-10">
                <v-col align-self="center" xs="12" offset-xs="0" sm="8" offset-sm="2" md="6" offset-md="3" lg="4"
                    offset-lg="4">
                    <v-card elevation="3" class="pa-6 text-center">
                        <v-icon color="success" size="48">mdi-check-circle-outline</v-icon>
                        <div class="headline mt-4 mb-2">{{ $t('registration_successful') }}</div>
                        <v-card-text class="mt-2">
                            {{ $t('check_email_for_verification') }}
                        </v-card-text>
                        <v-card-actions class="justify-center mt-2">
                            <v-btn color="primary" large :to="{ name: 'login' }">
                                {{ $t('go_to_login') }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'RegisterSuccess'
}
</script>